import type { DevelopmentContentLastUpdated } from '../../types';
import type { OptionGroup } from '~/features/common/components/FilterMultiSelect';
import { Select, Option } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';

const MENU_WIDTH_PX = 165;

interface DevelopmentContentSearchLastUpdatedFilterProps {
  selection: DevelopmentContentLastUpdated;
  onSelectionChange: (value: DevelopmentContentLastUpdated) => void;
  options: OptionGroup[];
}

export const DevelopmentContentSearchLastUpdatedFilter = ({
  selection,
  onSelectionChange,
  options,
}: DevelopmentContentSearchLastUpdatedFilterProps) => {
  const LAST_UPDATED = I18n.t('js.learner.development_content.filters.last_updated');
  const lastUpdatedOptions = options.length ? options[0].items : [];

  return (
    <Select
      data-testid="last-updated-filter"
      hideLabel
      label={LAST_UPDATED}
      onSelectionChange={onSelectionChange}
      title={LAST_UPDATED}
      selectedKey={selection}
      width={MENU_WIDTH_PX}
    >
      {lastUpdatedOptions?.map(({ label, value }) => (
        <Option data-testid={value} key={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};
